import { Relation } from './relation.model';
export class Company extends Relation {

}
